module.exports = __webpack_public_path__ + "media/drum-roll.284c049d.mp3";